export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10823.4f9d90c4.jpg";